import parseServerErrors from '@utils/parseServerErrors';
import { FC } from 'react';
import * as Sentry from '@sentry/react';
import composeErrorMessage from '@utils/composeErrorMessage';
import { useCheckoutConfigContext } from '@contexts/CheckoutConfig';

const ErrorFallback: FC<{ error: any }> = ({ error }) => {
  const codes = parseServerErrors(error);
  console.log(error);

  const ctx = useCheckoutConfigContext();

  Sentry.captureMessage(
    composeErrorMessage({
      code: 'ERROR_FALLBACK',
      message: error?.message,
      errorObject: error,
      checkout: ctx.checkout,
      checkoutData: ctx.checkoutData,
      organization: ctx.checkout.organization.name,
      campaignId: ctx.checkout.campaign.id,
      token: ctx.checkout.token,
    }),
  );

  return (
    <div
      style={{
        display: 'flex',
        fontFamily: 'Montserrat, sans-serif',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <div style={{ fontSize: '30px', paddingBottom: 20, textAlign: 'center' }}>
        Ops! Something went wrong.
      </div>

      {codes && (
        <div style={{ fontSize: '20px', paddingBottom: 10, color: 'red', textAlign: 'center' }}>
          {codes.map((error) => {
            switch (error.code) {
              case 'CHECKOUT:ORGANIZATION:INVALID':
                return 'The organization is invalid.';
              case 'CHECKOUT:CAMPAIGN:INVALID':
                return 'The campaign is invalid.';
              case 'CHECKOUT:PAYMENT_METHODS:MISSING':
                return 'No payment method is enabled.';
              case 'CHECKOUT:FORM:INVALID':
                return 'The form does not exist or is invalid.';
              case 'CHECKOUT:TOKEN:INVALID':
                return 'The provided token is invalid.';

              default:
                return "We're sorry, but something went wrong. Please try again later.";
            }
          })}
        </div>
      )}

      {import.meta.env.MODE === 'development' && (
        <div>
          <div style={{ fontSize: '20px', paddingBottom: 10, color: 'red', textAlign: 'center' }}>
            {error.message}
          </div>

          {/* Print stack or json of error */}
          <div style={{ textAlign: 'left' }}>
            {error.stack
              ? error.stack.split('\n').map((line, i) => (
                  <code key={`${i}-${line}`} style={{ lineHeight: 0.6 }}>
                    <pre>
                      {line}
                      <br />
                    </pre>
                  </code>
                ))
              : JSON.stringify(error, null, 2)
                  .split('\n')
                  .map((line, i) => (
                    <code key={`${i}-${line}`} style={{ lineHeight: 0.6 }}>
                      <pre>
                        {line}
                        <br />
                      </pre>
                    </code>
                  ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ErrorFallback;
